import { render, staticRenderFns } from "./FinanceTabBalanceLedger.vue?vue&type=template&id=1d5b835b&scoped=true"
import script from "./FinanceTabBalanceLedger.vue?vue&type=script&lang=js"
export * from "./FinanceTabBalanceLedger.vue?vue&type=script&lang=js"
import style0 from "./FinanceTabBalanceLedger.vue?vue&type=style&index=0&id=1d5b835b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5b835b",
  null
  
)

export default component.exports